import { useEffect, useState } from "react";

const TARGET = new Date("2026-08-28T00:00:00").getTime();

export default function Countdown() {
  const calc = () => {
    const diff = TARGET - Date.now();
    if (diff <= 0) return { d: 0, h: 0, m: 0, s: 0 };
    return {
      d: Math.floor(diff / 86400000),
      h: Math.floor((diff / 3600000) % 24),
      m: Math.floor((diff / 60000) % 60),
      s: Math.floor((diff / 1000) % 60),
    };
  };
  const [t, setT] = useState(calc());

  useEffect(() => {
    const id = setInterval(() => setT(calc()), 1000);
    return () => clearInterval(id);
  }, []);

  const Box = ({ value, label, testid }) => (
    <div className="flex flex-col items-center" data-testid={testid}>
      <div className="font-heading text-4xl sm:text-6xl lg:text-7xl text-gradient-gold leading-none">
        {String(value).padStart(2, "0")}
      </div>
      <div className="text-[10px] sm:text-xs uppercase tracking-[0.3em] text-white/70 mt-2 font-semibold">
        {label}
      </div>
    </div>
  );

  return (
    <div className="flex gap-4 sm:gap-8 lg:gap-12 items-center" data-testid="hero-countdown">
      <Box value={t.d} label="Días" testid="countdown-days" />
      <div className="text-3xl sm:text-5xl text-white/30 font-heading">:</div>
      <Box value={t.h} label="Horas" testid="countdown-hours" />
      <div className="text-3xl sm:text-5xl text-white/30 font-heading">:</div>
      <Box value={t.m} label="Min" testid="countdown-minutes" />
      <div className="text-3xl sm:text-5xl text-white/30 font-heading hidden sm:block">:</div>
      <Box value={t.s} label="Seg" testid="countdown-seconds" />
    </div>
  );
}
